<template>
  <div
    :class="{
      content: true,
      page: page.total > queryParams.Limit,
    }"
    ref="content"
  >
    <div class="main-content">
      <div class="search-box" ref="search">
        <a-form>
          <a-row>
            <a-col :sm="4">
              <s-input
                title="卡号"
                :labelCol="8"
                :valueCol="14"
                v-model:value="queryParams.CardNumber"
              />
            </a-col>
            <a-col :sm="4">
              <s-input
                title="姓名"
                :labelCol="8"
                :valueCol="14"
                v-model:value="queryParams.Name"
              />
            </a-col>
            <a-col :sm="4">
              <s-input
                title="手机号"
                :labelCol="8"
                :valueCol="15"
                v-model:value="queryParams.Mobile"
              />
            </a-col>

            <a-col>
              <a-button type="primary" @click="getDataList(1)"> 查询 </a-button>
              <a-button
                type="primary"
                @click="reset(() => resetFun())"
                danger
                style="margin-left: 10px"
              >
                重置
              </a-button>

              <a-button
                type="primary"
                @click="$refs.cardForm.open()"
                style="margin-left: 10px"
              >
                添加会员卡
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="data-list">
        <a-table
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :loading="loading"
          :row-key="(record) => record.id"
          :scroll="{ y: height, x: width }"
          @change="onChangeTable"
        >
          <template #bodyCell="{ column, record, index }">
            <template v-if="column.key === 'index'">
              {{ (page.page - 1) * queryParams.Limit + index + 1 }}
            </template>

            <template v-if="column.key === 'customerName'">
              <div class="username" v-if="record.customerName">
                <span>{{ record.customerName }}</span>
                <span style="font-size: 12px">({{ record.customerMobile }})</span>

                <span v-if="record.customerSex == 1" class="sex man">
                  <ManOutlined />
                </span>
                <span v-else-if="record.customerSex == 2" class="sex feman">
                  <WomanOutlined />
                </span>
                <span v-else class="sex">
                  <ManOutlined />
                </span>
              </div>
              <span v-else>未绑定用户</span>
            </template>

            <template v-if="column.key === 'lastCostTime'">
              <span v-if="record.lastCostTime">{{
                $filters.formatDate(record.lastCostTime)
              }}</span>
              <span v-else>暂无消费</span>
            </template>

            <template v-if="column.key === 'action'">

              <a-tooltip>
                <template #title>会员卡充值</template>
                <a @click.stop="$refs.card.open(record.cardNumber)">
                  <icon-font type="icon-caiwu1" />
                </a>
              </a-tooltip>

              <a-divider type="vertical" />

              <a-tooltip>
                <template #title>删除会员卡</template>
                <a @click.stop="delForm(() => delFormFun(record))">
                  <DeleteOutlined />
                </a>
              </a-tooltip>
            </template>
          </template>
        </a-table>
      </div>
    </div>

    <div class="pagination">
      <a-pagination
        :total="page.total"
        v-model:current="page.page"
        v-model:page-size="queryParams.Limit"
        :hide-on-single-page="true"
        :show-size-changer="true"
        :page-size-options="['20', '40', '100', '200']"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
      >
        <template #itemRender="{ page, type }">
          <a v-if="type === 'prev'" class="ant-pagination-item-link">上一页</a>
          <a v-else-if="type === 'next'" class="ant-pagination-item-link">
            下一页
          </a>
          <span v-else>{{ page }}</span>
        </template>
      </a-pagination>
      <span>数据总数：{{ page.total }}</span>
    </div>

    <Card ref="card" @ok="getDataList(page.page)" />
    <CardForm ref="cardForm" @ok="getDataList(1)" />
  </div>
</template>

<script>
import { defineComponent, ref, createVNode } from 'vue'
import {
  ManOutlined,
  WomanOutlined,
  ExclamationCircleOutlined,
  DeleteOutlined
} from '@ant-design/icons-vue'
import { FinAccountClass } from '@/apis/fin'
import page from '@/mixins/page'
import Card from '@/components/counter/forms/member/Card.vue'
import CardForm from '@/components/forms/marketing/CardForm'

const api = new FinAccountClass()
export default defineComponent({
  mixins: [page],
  components: {
    ManOutlined,
    WomanOutlined,
    Card,
    CardForm,
    DeleteOutlined
  },
  setup () {
    const loading = ref(false)
    const height = ref(500)
    const width = ref(500)

    return {
      loading,
      height,
      width
    }
  },

  data () {
    return {
      sortOrder: '',
      columns: [
        {
          title: '卡号',
          key: 'cardNumber',
          dataIndex: 'cardNumber',
          width: 200
        },
        {
          title: '会员信息',
          key: 'customerName',
          dataIndex: 'customerName',
          width: 300
        },
        {
          title: '余额',
          key: 'balance',
          dataIndex: 'balance',
          width: 100,
          sorter: true
        },
        {
          title: '总消费',
          key: 'totalOutlay',
          dataIndex: 'totalOutlay',
          width: 100
        },
        {
          title: '最近消费时间',
          key: 'lastCostTime',
          dataIndex: 'lastCostTime'
        },
        {
          title: '操作',
          key: 'action',
          dataIndex: 'action',
          width: 100
        }
      ]
    }
  },
  created () {
    this.getDataList(1)
  },
  methods: {
    onChangeTable (pagination, filters, sorter) {
      const { field, order } = sorter

      if (order && field) {
        this.queryParams.Orderby = order
        this.queryParams.OrderField = field
        this.getDataList(1)
      } else {
        this.resetFun()
      }
    },
    getDataList (page) {
      this.loading = true
      this.page.page = page
      const q = { ...this.queryParams }
      q.Offset = (page - 1) * q.Limit
      api.cards(q).then((resp) => {
        this.list = resp.data
        this.page.total = resp.total
        this.loading = false
        this.getTableHeight()
      })
    },
    resetFun () {
      this.queryParams = {
        Limit: 20
      }

      this.getDataList(1)
    },
    delFormFun (record) {
      const _this = this
      _this.$confirm({
        title: '确定删除?',
        icon: createVNode(ExclamationCircleOutlined),
        content: createVNode(
          'div',
          {
            style: 'color:red;'
          },
          `即将删除数据：${record.cardNumber}`
        ),

        onOk () {
          api.delCard(record.id).then(() => {
            _this.$message.success('删除成功！')
            _this.getDataList(1)
          })
        }
      })
    },

    getTableHeight () {
      const paddingBottom = this.page.total > this.queryParams.Limit ? 50 : 9
      const mainPadding = 30
      const thead = 56
      this.height =
        this.$refs.content.offsetHeight -
        this.$refs.search.offsetHeight -
        thead -
        paddingBottom -
        mainPadding

      this.width = this.$refs.search.offsetWidth - 10
    }
  }
})
</script>

<style lang="less" scoped>
.username {
  display: flex;
  align-items: center;
  img {
    display: block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid #ccc;
  }
  span {
    margin-left: 5px;
    &.sex {
      font-size: 12px;
      color: #ccc;
      &.man {
        color: rgb(66, 48, 228);
      }
      &.feman {
        color: rgb(228, 48, 48);
      }
    }
  }
}
.search-box {
  position: relative;
  z-index: 9;
}
</style>
